import { createSlice } from "@reduxjs/toolkit";
import { roleManagementReducer } from "../extraReducers/roleManagementReducer";

// 定义初始化数据
const initialState = {
  roleList: {} as any,
  adminList: {} as any,
};

const roleManagementSlice = createSlice({
  name: "roleManagement",
  initialState,
  reducers: {},
  extraReducers: roleManagementReducer,
});

// 默认导出,到处的文件需要在store入口文件引入
export default roleManagementSlice.reducer;
